export default "__VITE_ASSET__BMvnthD5__"